import { Box, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Menu from "./common/menu";
import Container from "@mui/material/Container";
import { download, fetchOrders } from "./common/apiCalls";
import { TableStructure } from "./common/tableStructure";
import { toast } from "react-toast";
import { dateFilters } from "./common/constants";
import { EVENTS } from "./events_constant";
import { fetchUserDetailsAndSetUserForAnalytics, logEventToAnalyticsPlatform } from "../../helper/events";

export const DocumentUploadAppointments = ({ fetchData, setFetchData, searchAppointment }) => {
  const [page, setPage] = useState(1);
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedSubTab, setSelectedSubTab] = useState("PENDING");
  const subTabs = [
    { label: "All Attended", value: "ALL" },
    { label: "Pending", value: "PENDING" },
    { label: "Submitted", value: "SUBMITTED" },
    { label: "Rejected", value: "REJECTED" },
    { label: "Completed", value: "DOCUMENT_NOT_REQUIRED" },
  ];
  const dateFilterObject = JSON.parse(sessionStorage.getItem("dateFilterObject"));
  const dateFilterName = dateFilterObject?.name ? dateFilterObject.name : "Rolling 1 Month";
  const selectedDateFilter = dateFilters.find((elem) => elem.name === dateFilterName);
  const startDate = dateFilterObject?.startDate ? dateFilterObject.startDate : selectedDateFilter.startDate;
  const endDate = dateFilterObject?.endDate ? dateFilterObject.endDate : selectedDateFilter.endDate;
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortLabel, setSortLabel] = useState("");

  const fetchOrderData = async () => {
    try {
      setLoading(true);
      let response = await fetchOrders(["OFFLINE_CONSULTS"], ["DOCUMENT_UPLOAD"], [selectedSubTab], startDate, endDate, page, searchAppointment, false, sortLabel, sortDirection);
      setOrders(response.data.requestDetails);
      setTotalRows(response.data.totalRecords ? response.data.totalRecords : 0);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const tokenExpired = localStorage.getItem("tokenExpired");
      if (tokenExpired === "true") {
        localStorage.clear();
        history.push("/login");
      } else {
        toast.error("Failed to fetch data");
      }
    }
  };

  const exportOrderData = async () => {
    try {
      setExportLoading(true);
      let response = await fetchOrders(["OFFLINE_CONSULTS"], ["DOCUMENT_UPLOAD"], [selectedSubTab], startDate, endDate, page, searchAppointment, true);
      download(response, "AppointmentData");
      setExportLoading(false);
    } catch (err) {
      setExportLoading(false);
      const tokenExpired = localStorage.getItem("tokenExpired");
      if (tokenExpired === "true") {
        localStorage.clear();
        history.push("/login");
      } else {
        toast.error("Failed to export data");
      }
    }
  };

  useEffect(() => {
    fetchOrderData();
  }, [fetchData]);


  useEffect(() => {
    const triggerEvents = async () => {
      await fetchUserDetailsAndSetUserForAnalytics();
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_SCREEN_LANDING,
        payload: {
          tab_name: EVENTS.TAB_NAME_DOCUMENT_UPLOAD,
          service_type: EVENTS.SERVICE_TYPE_OMS,
          screenName: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
        },
        schema: EVENTS.PC_SCREEN_LANDING.schema,
      })
    }
    triggerEvents();
  }, [])

  return (
    <Container maxWidth="xlg" className="pt-3">
      <Box className="pb-4" sx={{ width: "100%" }}>
        <Paper className="appointment-container" sx={{ width: "100%", mb: 2 }}>
          <Menu tab={4} history={history} totalRows={totalRows} service={"OFFLINE_CONSULTS"}></Menu>
          <TableStructure
            orders={orders}
            totalRows={totalRows}
            page={page}
            setPage={setPage}
            subTabs={subTabs}
            selectedSubTab={selectedSubTab}
            setSelectedSubTab={setSelectedSubTab}
            loading={loading}
            exportLoading={exportLoading}
            fetchData={fetchData}
            setFetchData={setFetchData}
            exportOrderData={exportOrderData}
            sortDirection={sortDirection}
            setSortDirection={setSortDirection}
            setSortLabel={setSortLabel}
          ></TableStructure>
        </Paper>
      </Box>
    </Container>
  );
};
